/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

import { IBlockElement, IButtonsElement, ITextElement } from "@chatcaptain/types/chatbot";
import { store } from "@/store";
import { BotStore } from "@/store/constants";

export const getElementDefault = (type: string): IBlockElement => {
  return {
    type,
    content: elementContents[type]
  } as IBlockElement;
}

const language = store.getters[BotStore.Getters.GET_DEFAULT_LANGUAGE];
const elementContents = {
  text: {message: {
    [language]: ""
  }} as ITextElement["content"],
  buttons: [{
    name: {[language]: "Unbenannter Button"},
    type: "block",
    value: "",
    payload: ""
  }] as IButtonsElement["content"]
}